import { render } from "./OrderSuccess.vue?vue&type=template&id=356abcea"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"

import "./OrderSuccess.vue?vue&type=style&index=0&id=356abcea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__